import React, { useState, useEffect } from "react";
import axiosConn from "config/axiosConn";
import { jwtDecode } from 'jwt-decode';
import Helper from "../../helper/Common_Helper.js"
import SideBar from "./SideBar";
import { Row, Col } from "reactstrap";
import { Form } from 'react-bootstrap';
import { IoIosPerson } from "react-icons/io";
import { FaComment } from "react-icons/fa";
import { MdDateRange, MdEmail, MdEmojiEvents, MdDelete } from "react-icons/md";
import { LuSchool } from "react-icons/lu";
import Langfield from "../../assets/Json/accountFormLang.json";
import { ImMobile } from "react-icons/im";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { toast } from "react-toastify";
import {changeLang,selectedVoice} from '../../redux/langSlice'
import {useDispatch} from 'react-redux'
import { FaBarsStaggered } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function Notification() {
    const [openSidebar, setOpenSidebar] = useState(false);
    const [notification, setNotification] = useState([])
    const [udise_id, setUdise] = useState('');
    const [status, setStatus] = useState(1);
    const [role, setRole] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const dispatch = useDispatch();
    const userData = useSelector(state => state.auth.user);
      const langSelected = userData.lang;
    const translations = Langfield[langSelected];
      const translate = (key) => {
        // Check if translations is defined and is an object
        if (typeof translations !== "object" || translations === null) {
          return key; // Return the key if translations is not available
        }
    
        // Handle undefined or non-string keys
        if (typeof key !== "string") {
          return key; // Return the value as is if key is not a string
        }
    
        return translations[key] || key.replace(/_/g, " "); // Use translation or fallback to the key
      };
    useEffect(() => {
        // let token = localStorage.getItem('token');
        if (userData) {
            // let auth = jwtDecode(token)
            setUdise(userData?.udise_id)
            setRole(userData?.role)
            // getLanguageFunction({ udise_id: userData?.udise_id });
            handleNotification({ collab_to_udise_id: userData?.udise_id })
        }
    }, [userData]);

    // const getLanguageFunction = async (data) => {
    //     try {
    //       const response = await axiosConn('post', 'get-language', data)
    //       if (response.data.status === 'success') {
    //         let lang = response.data.result.lang;
    //         let voice = response.data.result.voice;
    //         setLangSelected(lang);
    //         dispatch(changeLang(lang));
    //         dispatch(selectedVoice(voice));
    //         localStorage.setItem('langCode', lang);
    //         localStorage.setItem('voice', voice);
    //       }
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   }

    const handleNotification = async (postData, page = 1) => {
        try {
            postData['page'] = page;
            postData['limit'] = 10;
            // let response = await axiosConn('post', 'get-collaboration', postData)
            // if (response.data.status === 'success') {
            //     setNotification(response.data.result.response)
            //     setTotalPages(response.data.totalPages);
            //     setCurrentPage(response.data.currentPage);
            // }
        } catch (error) {
            console.log(error);
        }
    }

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            if (status === 1) {
                handleNotification({ collab_to_udise_id: udise_id }, page)
            } else {
                handleNotification({ collab_by_udise_id: udise_id }, page)
            }
        }
    };

    const handleChanges = (val) => {
        setNotification([])
        setStatus(val)
        if (val === 1) {
            handleNotification({ collab_to_udise_id: udise_id })
        } else {
            handleNotification({ collab_by_udise_id: udise_id })
        }
    }

    const handleUpdateNotification = async (id, action) => {
        try {
            if (action === 'delete') {
                const isConfirmed = window.confirm("Are you sure you want to delete this ?");
                if (!isConfirmed) {
                    return;
                }
            }
            let response = await axiosConn('post', 'update-collaboration', { id: id, action: action })
            if (response.data.status === 'success') {
                if (status === 1) {
                    handleNotification({ collab_to_udise_id: udise_id })
                } else {
                    handleNotification({ collab_by_udise_id: udise_id })
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    const viewFile = (filePath, id) => {
        if (filePath.length == 0) {
            toast.warning("Image not uploaded"); return
        }
        window.open(`https://ecoclubs.education.gov.in/viewUpload/${filePath}`, "_blank");
        handleUpdateNotification(id, 'update')
    };
    const handleSidebar = () => {
        setOpenSidebar(!openSidebar);
      }

    return (
        <>
            <section className="scholdashbrdSec">
            <div className="desktopView" style={{ marginTop: 70, textAlign: "end" }}>
                            <Link className="button green bars" onClick={handleSidebar}><FaBarsStaggered size={20} /></Link>
                        </div>
                        <div className={`sidebar ${openSidebar ? "open" : "hideen"}`}>
                <SideBar langSelected={langSelected} index={8} role={role} />
                </div>
                <div className="schlDashbrdRgt">
                    <div className="container bg-white p-3 text-start pageContainer">
                        <div class="card-header pgHederSpceArnd"><h5 class="card-title">{translate("Collaboration Requests")}</h5></div>

                        <Row>
                            <Col md="12">
                                <div className="d-flex justify-content-center w-100 mb-4" >
                                    <div className="d-flex justify-content-start mr-5" style={{ marginRight: '25px' }}>
                                        <Form.Check name="status" value="1" style={{ marginRight: '15px' }} type="radio" defaultChecked onClick={() => handleChanges(1)}></Form.Check>
                                        <Form.Label className="ml-2">{translate("Received")}</Form.Label>
                                    </div>
                                    <div className="d-flex justify-content-start mr-5" style={{ marginRight: '25px' }}>
                                        <Form.Check name="status" value="2" style={{ marginRight: '15px' }} type="radio" onClick={() => handleChanges(2)}></Form.Check>
                                        <Form.Label className="ml-2">{translate("Sent")}</Form.Label>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="gy-3 gx-3 justify-content-between">
                            {status === 1 ? <>
                                {notification && notification.length > 0 ? (
                                    notification.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                        .map((item, i) => (
                                            <Col xs={12} sm={12} md={6} lg={6} xxl={6} className="ropOneDivNewIn">
                                                <span className="rop_num">{i + 1}</span>
                                                <ul className="d-flex justify-content-start flex-wrap">
                                                    <li><IoIosPerson color="#f29c62" size={20} /> Contact Person <span>{item.contact_person}</span></li>
                                                    <li><MdEmail color="#f29c62" size={20} /> Contact Email <span>{item.contact_email}</span></li>
                                                    <li><ImMobile color="#f29c62" size={20} /> Contact Number <span>{item.contact_number}</span></li>
                                                    <li><MdDateRange color="#f29c62" size={20} /> Date of Request <span>{Helper.formatDate(item.created_at)}</span></li>
                                                    <hr className="lineBreak" />
                                                    <li><MdEmojiEvents color="#f29c62" size={20} /> Event Name <span>{item.event_name}</span></li>
                                                    <li><IoCheckmarkDoneSharp color="#f29c62" size={20} /> View Document<span>
                                                        {/* {item.status == 1 ?
                                                            <Button onClick={() => handleUpdateNotification(item._id, 'update')}><FaEyeSlash size={20} /></Button>
                                                            : <Button className="btn-info" disabled><FaEye size={20} /></Button>
                                                        } */}
                                                        <button className="btn btn-success" onClick={() => viewFile(item?.file, item._id)} >View</button></span>
                                                    </li>
                                                    <li><LuSchool color="#f29c62" size={20} /> School Name <span>{item?.collab_by_school_name}</span></li>
                                                    <li className="w-100"><FaComment color="#f29c62" size={20} /> Comment<span> {item.comment} </span></li>
                                                </ul>
                                            </Col>
                                        ))
                                ) : (
                                    <p colSpan="8" className="text-center">Data not found.</p>
                                )}
                            </> : <>
                                {notification && notification.length > 0 ? (
                                    notification.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                        .map((item, i) => (
                                            <Col xs={12} sm={12} md={6} lg={6} xxl={6} className="ropOneDivNewIn">
                                                <span className="rop_num">{i + 1}</span>
                                                <ul className="d-flex justify-content-start flex-wrap">
                                                    <li><IoIosPerson color="#f29c62" size={20} /> Contact Person <span>{item.contact_person}</span></li>
                                                    <li><MdEmail color="#f29c62" size={20} /> Contact Email <span>{item.contact_email}</span></li>
                                                    <li><ImMobile color="#f29c62" size={20} /> Contact Number <span>{item.contact_number}</span></li>
                                                    <li><MdDateRange color="#f29c62" size={20} /> Date of Request <span>{Helper.formatDate(item.created_at)}</span></li>
                                                    <hr className="lineBreak" />
                                                    <li><MdEmojiEvents color="#f29c62" size={20} /> Event Name <span>{item.event_name}</span></li>
                                                    <li><MdEmail color="#f29c62" size={20} />Status <span>{item.status == 1 ? 'Pending' : 'Viewed'}</span></li>
                                                    <li><LuSchool color="#f29c62" size={20} /> School Name <span>{item?.collab_to_school_name}</span></li>
                                                    <li><ImMobile color="#f29c62" size={20} />Action <span>
                                                        <button style={{ backgroundColor: "transparent", border: "none" }} onClick={() => handleUpdateNotification(item._id, 'delete')}><MdDelete size={20} color="#bb2d3b" /></button>
                                                        <button className="btn btn-success" onClick={() => viewFile(item?.file)} >View</button>
                                                    </span></li>
                                                    <li className="w-100"><FaComment color="#f29c62" size={20} /> Comment<span> {item.comment} </span></li>
                                                </ul>
                                            </Col>
                                        ))
                                ) : (
                                    <p colSpan="8" className="text-center">Data not found.</p>
                                )}
                            </>}
                        </Row>
                    </div>
                    {totalPages > 1 ?
                        <div className="mb-3">
                            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>{translate("Previous")}</button>
                            <span>Page {currentPage} of {totalPages}</span>
                            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} > {translate("Next")} </button>
                        </div>
                        : ""}
                </div>
            </section >
        </>
    );
}

export default Notification;
